var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content-marketing',[_c('div',[_c('page-title',{attrs:{"title_text":"دستگاه های کارتخوان","icon":"card"}}),_c('agent-open')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }